

// Close side navigation
export function w3_close() {
  document.getElementById("mySidebar").style.display = "none";
}
